import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useCheckLcrWorksheetQueryStatus = (lcrSessionId, worksheetId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useQuery(
    ['lcrWorksheetQueryStatus', lcrSessionId, worksheetId],
    () => axiosInstance.get(
      liveCleanroom(orgId).getWorksheetQueryStatus(lcrSessionId, worksheetId),
    ),
    {
      enabled: !!worksheetId && !!lcrSessionId,
      select: (response) => response.data,
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error checking query status',
            type: 'error',
          }),
        );
      },
    },
  );
};
